export class QuestionBase<T>{
    id: string;
    value: T;
    key: string;
    label: string;
    labelText : string;
    required: boolean;
    order: number;
    controlType: string;
    readonly: boolean;
    class: string;
    backendField: string;
    dataType: string;
    dataValues: {
        code: string;
        name: string;
    }[];
    type: string;
    code: string;
    show: boolean;

    constructor(options: {
        id?:string,
        value?: T,
        key?: string,
        label?: string,
        required?: boolean,
        order?: number,
        controlType?: string
        readonly?: boolean;
        class?: string;

    } = {}) {
        this.id = options.id;
        this.value = options.value;
        this.key = options.key || '';
        this.label = options.label || '';
        this.required = !!options.required;
        this.order = options.order === undefined ? 1 : options.order;
        this.controlType = options.controlType || '';
        this.readonly = options.readonly || false;
        this.class = options.class || '';

    }
}




// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/lodash/lodash.js!./~/tslint-loader!./src/app/components/question-base.ts